<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard shape="tab"
                       @on-complete="wizardComplete"
                       error-color="#EB5E28"
                       color="#66615B"
                       title="Authentic.net"
                       subtitle="Submit Fraud Report">
            <tab-content title="Product"
                         :before-change="validateFirstStep"
                         icon="ti-bag">
              <first-step ref="firstStep"></first-step>
            </tab-content>

            <tab-content title="Store / Seller Info"
                         :before-change="validateSecondStep"
                         icon="ti-shopping-cart">
              <second-step ref="secondStep"></second-step>
            </tab-content>

            <tab-content title="Contact Info"
                         icon="ti-user">
              <h5 class="text-center">Please let us know how to reach you.</h5>
              <div class="row">
                <div class="col-md-5 col-md-offset-1">
                  <div class="form-group">
                    <label class="control-label">Name</label>
                    <input class="form-control"
                          type="text"
                          name="buyerName"
                          v-validate="modelValidations.buyerName"
                          v-model="model.buyerName">
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group">
                    <label class="control-label">Email</label>
                    <input class="form-control"
                          type="text"
                          name="buyerEmail"
                          v-validate="modelValidations.buyerEmail"
                          v-model="model.buyerEmail">
                    <small class="text-danger" v-show="buyerEmail.invalid">
                      {{ getError('buyerEmail') }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5 col-md-offset-1">
                  <div class="form-group">
                    <label class="control-label">
                      Phone
                    </label>
                    <input class="form-control"
                          type="text"
                          name="buyerPhone"
                          v-validate="modelValidations.buyerPhone"
                          v-model="model.buyerPhone">
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group">
                    <label class="control-label">
                      City
                    </label>
                    <input class="form-control"
                          type="text"
                          name="buyerCity"
                          v-validate="modelValidations.buyerCity"
                          v-model="model.buyerCity">
                    <small class="text-danger" v-show="buyerCity.invalid">
                      {{ getError('buyerCity') }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5 col-md-offset-1">
                  <div class="form-group">
                    <label class="control-label">
                      State
                    </label>
                    <input class="form-control"
                          type="text"
                          name="buyerState"
                          v-validate="modelValidations.buyerState"
                          v-model="model.buyerState">
                    <small class="text-danger" v-show="buyerState.invalid">
                      {{ getError('buyerState') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group">
                    <label class="control-label">
                      Country
                    </label>
                    <input class="form-control"
                          type="text"
                          name="buyerCountry"
                          v-validate="modelValidations.buyerCountry"
                          v-model="model.buyerCountry">
                    <small class="text-danger" v-show="buyerCountry.invalid">
                      {{ getError('buyerCountry') }}
                    </small>
                  </div>
                </div>
              </div>
              <!-- <h2 class="text-center text-space">Yuhuuu!
                <br>
                <small>Click on "<b>Finish</b>" to join our community</small>
              </h2> -->
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Next</button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd">Finish</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import FirstStep from './Wizard/FirstStep.vue'
  import SecondStep from './Wizard/SecondStep.vue'
  import swal from 'sweetalert2'
  import db from '@/components/firebase/init'

  export default {
    computed: {
      ...mapFields(['buyerName', 'buyerEmail', 'buyerPhone', 'buyerCity', 'buyerState', 'buyerCountry'])
    },
    data () {
      return {
        wizardModel: {},
        model: {
          buyerName: '',
          buyerEmail: '',
          buyerPhone: '',
          buyerCity: '',
          buyerState: '',
          buyerCountry: '',
          code: ''
        },
        modelValidations: {
          buyerEmail: {
            email: true
          },
          buyerCity: {
            required: true
          },
          buyerState: {
            required: true
          },
          buyerCountry: {
            required: true
          }
        }
      }
    },
    components: {
      FormWizard,
      TabContent,
      FirstStep,
      SecondStep
    },
    methods: {
      init () {
        if (this.$route.params.code) this.model.code = this.$route.params.code
        else if (this.$route.query.code) this.model.code = this.$route.query.code
      },
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        return this.$refs.secondStep.validate()
      },
      wizardComplete () {
        this.validate()
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.firstStep.model,
          ...this.$refs.secondStep.model,
          ...this.model
        }
        console.log(this.wizardModel)
        db.collection(`fraudReports`).add(this.wizardModel)
        .then(result => {
          swal.fire('Thank You!', 'Your report has been submitted. We may update you with research results or reach out to you if we need more info.', 'success')
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FraudReport/FraudReport.vue